<div class="mt-2">
  <!-- back -->
  <div class="mb-3 d-flex align-items-center gap-2">
    <span class="btn btn-sm rounded-1 btn-warning" (click)="sharedService.back()">
      <i class="bi bi-arrow-left"></i>
      <span class="ms-2">{{'upload_back'|translate}}</span>
    </span>
    <!-- download mẫu tại đây -->
     <div>
       <a (click)="downloadSample()" class="btn btn-sm rounded-1 btn-outline-primary px-4">
         <i class="bi bi-download me-2"></i>
         {{'upload_download_sample'|translate}}
       </a>
     </div>
  </div>
  <div class="mb-4">
    <div class="text-center">
      <div class="upload-area p-3" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" [class.drag-over]="isDragOver" [class.has-file]="selectedFile">
        <div *ngIf="!selectedFile; else fileSelectedBlock">
          <div class="upload-icon mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#6c757d" viewBox="0 0 16 16">
              <path
                d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path
                d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
            </svg>
          </div>
          <!-- <span class="mb-3 fs-5">{{'upload_your_doccument'|translate}}</span> -->
          <p class="text-muted mb-4">{{'upload_click_to_drag_drop'|translate}}</p>
          <!-- <div class="supported-formats mb-3">
            <span class="badge bg-light text-dark me-2">SVG</span>
            <span class="badge bg-light text-dark me-2">PNG</span>
            <span class="badge bg-light text-dark me-2">JPG</span>
            <span class="badge bg-light text-dark">GIF</span>
          </div> -->
          <!-- <p class="small text-muted">{{'upload_max_size'|translate}}: 25MB</p> -->
          <input type="file" id="fileUpload" class="d-none" (change)="onFileSelected($event)" accept=".csv">
          <div class="d-flex gap-2 justify-content-center align-items-center">
            <label for="fileUpload" class="btn btn-sm rounded-1 btn-outline-primary px-4">
              <i class="bi bi-plus-lg"></i>
            </label>

            <button class="btn btn-sm rounded-1 btn-primary px-5" (click)="upload()" [disabled]="parsedData.length < 1">
              <span *ngIf="!isUploading">{{'btn_upload'|translate}}</span>
              <span *ngIf="isUploading">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ 'uploading' | translate }}
              </span>
            </button>

          </div>
        </div>

        <ng-template #fileSelectedBlock>
          <div class="file-preview">
            <div class="file-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#0d6efd" viewBox="0 0 16 16">
                <path
                  d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
              </svg>
            </div>
            <div class="file-info">
              <h6 class="mb-1">{{ selectedFile?.name }}</h6>
              <p class="small text-muted mb-2">{{ selectedFile?.size}}</p>
              <div class="progress mb-3" *ngIf="isUploading">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                  [style.width]="uploadProgress + '%'" [attr.aria-valuenow]="uploadProgress">
                </div>
              </div>
            </div>
            <button type="button" class="btn-close" (click)="clearFile()" aria-label="Close"></button>
          </div>
        </ng-template>
      </div>

      <div *ngIf="errorMessage" class="alert alert-danger mt-3">
        {{ errorMessage }}
      </div>

    </div>
  </div>
  <!-- Content Display Section -->
  <div class="" *ngIf="parsedData.length > 0">
    <div class="card-body p-4">
      <h5 class="card-title mb-3 fw-bold text-center border-bottom pb-2">{{'upload_file_content'|translate}}</h5>
      <!-- <div class="form-floating">
        <textarea class="form-control" #fileData id="contentTextarea" style="height: 200px" readonly></textarea>
        <label for="contentTextarea">{{'upload_parse_content_file'|translate}}</label>
      </div> -->
      <table class="table">
        <thead>
          <tr>
            <th scope="col" *ngFor="let key of keyFile" class="text-uppercase fw-bold">{{key}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of parsedData">
            <td *ngFor="let key of keyFile">
              {{ item[key] || '' }}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="d-flex justify-content-center mt-3">
        <button class="px-5 btn btn-sm rounded-1 btn-warning" (click)="clearAll()">
          {{'btn_clear'|translate}}
        </button>
      </div> -->
    </div>
  </div>
</div>
